import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import { imagesBasePath } from '../../../../play-core/utils/base-path';
import { useVideoConfig } from '../../config/VideoAppContext';
import { PlayContainer } from '../PlayContainer/PlayContainer';
import { SwimlaneTitle } from '../Swimlane/SwimlaneTitle';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ImageSection = ({
  title,
  image
}) => {
  const {
    usePreview
  } = useVideoConfig();
  if (usePreview) {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(SwimlaneTitle, {
        title: title
      }), /*#__PURE__*/_jsx(PlayContainer, {
        children: /*#__PURE__*/_jsx(Image, {
          src: `${imagesBasePath}/sections/${image}`
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(Fragment, {});
};
const Image = styled.img.withConfig({
  displayName: "ImageSection__Image",
  componentId: "sc-1h04g4x-0"
})(["width:100%;"]);